var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPwHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_6716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 14.1467C4.68804 13.3067 5.0926 12.1068 6.10929 11.5258C6.74861 11.1605 7.11333 10.4737 7.82418 10.0859C8.29344 9.82998 8.93266 9.53384 9.31257 9.19614C10.9963 7.69951 14.491 8.03131 16.6089 8.03131C20.1586 8.03131 26.0732 10.837 26.0732 15.0203",
    stroke: "#C1C1C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4245 12.1074C10.3363 12.1074 11.2463 19.0964 15.2981 19.0964C16.9162 19.0964 18.616 17.5714 18.7926 15.8931C19.101 12.9632 17.758 12.1074 15.0069 12.1074",
    stroke: "#C1C1C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94141 24.681C5.0103 24.1298 6.24371 23.3741 6.65234 23.0932C7.41978 22.5656 7.94269 21.6911 8.74652 21.2317C10.0036 20.5134 11.2598 18.6089 12.3326 17.5361C13.1171 16.7516 14.5081 15.6248 15.0428 14.6891C15.6273 13.6662 16.9709 13.3068 17.5613 12.3622C18.1783 11.375 19.6221 10.9268 20.3261 10.0217C21.1021 9.024 22.1744 8.22956 23.1184 7.37999C23.81 6.75752 24.3787 6.01017 25.0346 5.35425C25.7127 4.67615 26.5374 3.41204 27.3615 3",
    stroke: "#C1C1C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_6716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.941406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPwHide);
export default __webpack_public_path__ + "static/media/icon-pw-hide.d0e498ef3c7290773f8e6e85927a0adb.svg";
export { ForwardRef as ReactComponent };